module.exports = __webpack_public_path__ + "img/xiao4.4fa8d14f.png";